import WildAppResource from "./WildAppResource";
import OrderAppResource from './OrderAppResource';
import FormsetAppResource from "./FormsetAppResource";
import JotFormDisclosureSessionAppResource from "./JotFormDisclosureSessionAppResource";
import Engine from "ss-js-engine/src/Engine";

class DisclosureAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'disclosure';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'disclosures';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'inProgress',
            'inProgressPdfs',
            'pdfsInUse',
            'attachments',
            'orderUuid',
            'formsetUuid',
            'onboardingComplete',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            order: OrderAppResource,
            formset: FormsetAppResource,
            jotFormDisclosureSessions: JotFormDisclosureSessionAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            order: 'order_uuid',
            formset: 'formset_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            orderUuid: {
                type: 'string',
            },
        };
    }

    apiPaths () {
        return {
            ...super.apiPaths(),
            'sign': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/sign'),
            'signUsingDocumentGenerator': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/sign-using-document-generator'),
        }
    }

    async sign(data) {
        const url = this.apiPaths().sign.replace('{uuid}', this.uuid);

        return await Engine.post(url, {
            ...data,
        });
    }

    async signUsingDocumentGenerator(data) {
        const url = this.apiPaths().signUsingDocumentGenerator.replace('{uuid}', this.uuid);

        return await Engine.post(url, {
            ...data,
        });
    }

}

export default DisclosureAppResource;
